module.exports = __webpack_public_path__ + "static/img/how-to-create_zh.36db068a.gif";